<template>
  <div class="animated fadeIn">
	<b-row>
	  <b-col md="12">
	  	 <b-card>
	  	 	<div slot="header">
            
            <strong>OFD Unique Customer Count</strong>
          
          </div>
          <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
           </b-col> 
           <b-col sm="12">
            <b-table responsive show-empty  :busy="isBusy" :items="uniqueitems" :fields="uniquefields"  :current-page="currentPage"  :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
            </b-table>
           </b-col>
          <!--  <b-col md="6" class="my-1" v-if='totalRows>20'>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> -->
	  	 </b-card>
	  </b-col>
	</b-row>
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
	data: function() {
    return {
    	totalRows:0,
    	isBusy:false,
		uniqueitems:[],
		uniquefields:[
		// { key: 'deliveryagentmasterid', label: 'Id', sortable: true, sortDirection: 'desc' },
		{ key: 'deliveryagentname', label: 'Delivery Agent Name', sortable: true, sortDirection: 'desc' },
		{ key: 'ofdshipmentcount', label: 'OFD Count', sortable: true, sortDirection: 'desc' },
		{ key: 'uniqueofdcustomercount', label: 'Unique OFD Count', sortable: true, sortDirection: 'desc' },
		{ key: 'shipmentstatus', label: 'Status', sortable: true, sortDirection: 'desc' },
		],
		currentPage:1,
		// perPage:20,
		bordered:true,
		pageOptions: [5, 10, 15,20],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
      };
    },
    created: function() {
       this.getOfdUniqueCustomerCountRiderWise();
    },
    methods: { 
    	getOfdUniqueCustomerCountRiderWise(){
    		this.isBusy=true;
    		var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            const obj = {     
		        hub_id:`${userInfo.pickuplocationmasterid}`,   
		      }
		    console.log("Obj",obj);
		    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getOfdUniqueCustomerCountRiderWise`, obj)
	        .then((result) => {
	        	this.isBusy=false;
	        	if(result.body.returnmsg=='Successful'){
	        	  this.uniqueitems = result.body.returnvalue;
	        	  this.totalRows = result.body.returnvalue.length;
	        	}else{
	        	  this.uniqueitems=[];
                  this.totalRows=0;
	        	}
	          
	          
	        })
	        .catch((ex) => {
	          console.log('error', ex)
	        })
    	}
    }
};

</script>
<style>
	
</style>